import { render } from "./cpu-load-page.vue?vue&type=template&id=18f2e75d"
import script from "./cpu-load-page.vue?vue&type=script&lang=ts"
export * from "./cpu-load-page.vue?vue&type=script&lang=ts"
script.render = render

export default script